<div class="container-fluid" id="mainContainer-dashboard">

    <div class="col-md-3 leftCol">
        <div class="Heading">
            Dashboard
        </div>

    </div>

    <div class="filtersContainer">

        <div class="col-md-2 filter-btn" appShowHide>
            <button type="button" class="btn-filter" data-toggle="collapse" data-target="#filterCollapse"
                aria-expanded="false" aria-controls="collapseExample" (click)="loadFilters()">
                <img src="../../../../../assets/icons/filter.png" id="navitem" width="16px" height="16px" alt=""
                    loading="lazy" style="margin: 0px 5px ;">
                Filters
            </button>
        </div>

        <div [ngClass]="loggedUserRole == 4 ? 'col-md-12 filterMainDivHide': 'col-md-10 filterMainDivHide'">

            <div class="col-md-8 filter-dashboard" id="filter-month-selector">
                <div>
                    <button (click)="selectorPressed(1)"
                        [ngClass]="selectorActive === 1  ? 'leftFilter-active' : 'leftFilter-inactive'"
                        (click)="todayPressed()" type="submit">Today</button>
                </div>
                <div>
                    <button (click)="selectorPressed(2)"
                        [ngClass]="selectorActive === 2  ? 'middleFilter-active' : 'middleFilter-inactive'"
                        type="submit">Yesterday</button>
                </div>
                <div>
                    <button (click)="selectorPressed(3)"
                        [ngClass]="selectorActive === 3  ? 'middleFilter-active' : 'middleFilter-inactive'"
                        type="submit">Last 7
                        days </button>
                </div>
                <div>
                    <button (click)="selectorPressed(4)"
                        [ngClass]="selectorActive === 4  ? 'rightFilter-active' : 'rightFilter-inactive'"
                        type="submit">Last
                        Month</button>
                </div>
                <form [formGroup]="dateForm">
                    <div class="datepicker">
                        <input id="startDate" type="text" placeholder="Custom" class="form-control datepicker-input"
                            bsDaterangepicker [(ngModel)]="selectedStartDate" style="cursor: pointer;"
                            formControlName="date" [bsConfig]="{ adaptivePosition: true,dateInputFormat:'YYYY-MM-DD'}"
                            [bsConfig]="bsConfig" (ngModelChange)="updateMyDate($event)" placement="bottom right">
                        <span id="iconCalendar">
                            <img src="../../../../../assets/icons/calendar.png" width="18px" height="18px"
                                class="d-inline-block align-top" alt="" loading="lazy">
                        </span>

                    </div>
                </form>
            </div>
        </div>

    </div>


    <div class="collapse" id="filterCollapse">
        <div class="filterCol">
            <form [formGroup]="filterForm" id="filterForm">
                <div [ngClass]="loggedUserRole == 1 || loggedUserRole == 2 ? 'filtersBox' : 'filtersBoxAdmin' ">
                    <label class="filterLbl" for="menuName">Admin Filters</label>
                    <div class="row filtersRow">
                        <div [ngClass]="loggedUserRole == 1 || loggedUserRole == 2 ? 'superAdmin' : 'admin' ">
                            <label class="lblInput" for="menuName">Brand</label>
                            <div class="filterInput">
                                <select class='form-control bulkInput selectpicker' id="spicker_brand"
                                    (ngModelChange)="selectBrand($event)" formControlName="brand"
                                    data-style="dropdownCustomStyle">
                                    <option selected value='' disabled
                                        data-content="<span class='text-secondary'>Nothing Selected</span>"></option>
                                    <option *ngFor="let brand of activeBrands" [ngValue]="brand.brand_id">
                                        {{brand.brand_name}} </option>
                                </select>
                            </div>
                        </div>
                        <div [ngClass]="loggedUserRole == 1 || loggedUserRole == 2 ? 'superAdmin' : 'admin' ">
                            <label class="lblInput" for="menuName">Franchise</label>
                            <div class="filterInput">
                                <select class='form-control bulkInput selectpicker' id="spicker_franchise"
                                    (ngModelChange)="selectFranchise($event)" formControlName="franchise"
                                    data-style="dropdownCustomStyle">
                                    <option selected value='' disabled
                                        data-content="<span class='text-secondary'>Nothing Selected</span>"></option>
                                    <option *ngFor="let franchise of franchises" [ngValue]="franchise.id">
                                        {{franchise.name}} </option>
                                </select>
                            </div>
                        </div>
                        <div>
                            <label class="lblInput" for="menuName">Outlet</label>
                            <div class="filterInput2">
                                <select class='form-control bulkInput selectpicker' id="spicker_shop"
                                    formControlName="shop" (ngModelChange)="selectShop($event)"
                                    data-style="dropdownCustomStyle" disabled="!showShops">
                                    <option selected value='' disabled
                                        data-content="<span class='text-secondary'>Nothing Selected</span>"></option>
                                    <option *ngFor="let shop of shops" [ngValue]="shop">
                                        {{shop.name}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

        </div>
    </div>

</div>




<div class="container-responsive" [ngClass]="!isFilterClicked ? 'filterNotClicked' : 'filterClicked'">
    <div class="container-fluid" id="mainContainer">

        <div *ngIf="!isDataLoaded" class="item">
            <ngx-skeleton-loader class="skelton-tiles" count="4" [theme]="{ 
            'border-radius': '0px',
            height: '100px',
            width:'24%', 'margin-top':'20px'
          }"></ngx-skeleton-loader>
        </div>

        <div *ngIf="isDataLoaded" class="tilerow">
            <dashboard-tile class="col-md-3" [dashboardTileType]="dashboardTileTypeTotal" [count]="totalCount">
            </dashboard-tile>
            <dashboard-tile class="col-md-3" [dashboardTileType]="dashboardTileTypeCompleted" [count]="completedCount">
            </dashboard-tile>
            <dashboard-tile class="col-md-3" [dashboardTileType]="dashboardTileTypeReady" [count]="readyCount">
            </dashboard-tile>
            <dashboard-tile class="col-md-3" [dashboardTileType]="dashboardTileTypeAccepted" [count]="acceptedCount">
            </dashboard-tile>
        </div>

        <div *ngIf="!isDataLoaded" class="item-child">
            <ngx-skeleton-loader class="skelton-tiles" count="4" [theme]="{ 
            'border-radius': '0px',
            height: '100px',
            width:'24%'
          }"></ngx-skeleton-loader>
        </div>

        <div *ngIf="isDataLoaded" class="tilerow">
            <dashboard-tile class="col-md-3" [dashboardTileType]="dashboardTileTypeCanceled" [count]="canceledCount">
            </dashboard-tile>
            <dashboard-tile class="col-md-3" [dashboardTileType]="dashboardTileTypeDeclined" [count]="declinedCount">
            </dashboard-tile>

            <div class="col-md-3">
                <div class="dashboardTile-Revenue icon-tile-style"
                    style="background-image: url('../../../../../assets/icons/pound.png');" (click)="onclickRevenue()">
                    <h1 [ngClass]="totalrevenue2.toString().length > 4 ? 'txtRevenueCount' : 'txtorderCount'">
                        {{currency}}{{totalrevenue}}</h1>
                    <div class="dashboardTile-inner  ">
                        <span class="txt-caption">Order Revenue</span>
                    </div>




                </div>
            </div>


            <div class="col-md-3">
                <div class="dashboardTile4">

                    <div class="dashboardTile-inner">
                        <h1 class="txtorderCount">Best</h1>
                        <span class="txt-caption">Selling Platform </span>
                    </div>


                    <img src={{bestSellingPlatform}} width="56px" alt="" loading="lazy" routerLink="/profile">

                </div>
            </div>
        </div>

        <div *ngIf="!isDataLoaded" class="item-child">
            <ngx-skeleton-loader class="skelton-tiles" count="4" [theme]="{ 
            'border-radius': '0px',
            height: '100px',
            width:'24%'
          }"></ngx-skeleton-loader>
        </div>

        <div *ngIf="isDataLoaded" class="tilerow">
            <div class="col-md-3">
                <div class="dashboardTile5 icon-tile-style">
                    <h1 [ngClass]="totalReservations.toString().length > 4 ? 'txtRevenueCount' : 'txtorderCount'"
                        style="padding-left :18%">
                        {{totalReservations}}</h1>
                    <div class="dashboardTile-inner " style="padding-left :18%">
                        <span class="txt-caption">Total Reservations</span>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="dashboardTile6 icon-tile-style"
                    style="background-image: url('../../../../../assets/icons/pound.png');">
                    <h1
                        [ngClass]="totalReservationsRevenue.toString().length > 4 ? 'txtRevenueCount' : 'txtorderCount'">
                        {{currency}}{{totalReservationsRevenue}}</h1>
                    <div class="dashboardTile-inner  ">
                        <span class="txt-caption">Reservations Revenue</span>
                    </div>
                </div>
            </div>


            <div class="col-md-3">
                <div class="dashboardTile7">

                    <div class="dashboardTile-inner">
                        <h1 class="txtorderCount">Best Zone</h1>
                        <span class="txt-caption">{{bestZone}} </span>
                    </div>

                </div>
            </div>

            <div class="col-md-3">
                <div class="dashboardTile8 icon-tile-style"
                    style="background-image: url('../../../../../assets/icons/pound.png');">
                    <h1 [ngClass]="totalNetRevenue.toString().length > 4 ? 'txtRevenueCount' : 'txtorderCount'">
                        {{currency}}{{totalNetRevenue}}</h1>
                    <div class="dashboardTile-inner  ">
                        <span class="txt-caption">Total Revenue</span>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <div class="mainContainerChart" id="mainContainerCharts ">

        <div class="main-barChart col-md-8">
            <div>
                <div class="dashboard-tabs">
                    <a (click)="onclickTab(1)" style="cursor: pointer;">
                        <div [ngClass]="tabActive === 1  ? 'tab-active' : 'tab-inactive'">
                            <h5>Orders Overview</h5>
                        </div>
                    </a>

                    <div class="middle-gap">

                    </div>
                    <a (click)="onclickTab(2)" style="cursor: pointer;">
                        <div [ngClass]="tabActive === 2  ? 'tab-active' : 'tab-inactive'">
                            <h5>Products Overview</h5>
                        </div>
                    </a>

                    <div class="middle-gap">

                    </div>

                    <a (click)="onclickTab(3)" style="cursor: pointer;">
                        <div [ngClass]="tabActive === 3  ? 'tab-active' : 'tab-inactive'">
                            <h5>Revenue Overview</h5>
                        </div>
                    </a>
                </div>

                <div *ngIf="!isDataLoaded" class="item">
                    <ngx-skeleton-loader class="skelton-best-selling" count="1" [theme]="{ 
                    'border-radius': '6px',
                    height: '350px'
                  }"></ngx-skeleton-loader>
                </div>

                <div *ngIf="tabActive === 1">
                    <div *ngIf="isDataLoaded" style="display: block">
                        <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels"
                            [options]="barChartOptions" [plugins]="barChartPlugins" [legend]="barChartLegend"
                            [chartType]="barChartType">
                        </canvas>
                    </div>
                </div>

                <div *ngIf="tabActive === 2">
                    <div *ngIf="isDataLoaded" style="display: block">

                        <canvas baseChart [data]="pieChartData" [labels]="pieChartLabels" [chartType]="pieChartType"
                            [options]="pieChartOptions" [plugins]="pieChartPlugins" [colors]="pieChartColors"
                            [legend]="pieChartLegend">
                        </canvas>

                    </div>
                </div>

                <div *ngIf="tabActive === 3">
                    <div *ngIf="isDataLoaded" style="display: block">
                        <canvas baseChart [datasets]="revenueBarChartData" [labels]="revenueBarChartLabels"
                            [options]="revenueBarChartOptions" [plugins]="barChartPlugins"
                            [legend]="revenueBarChartLegend" [chartType]="revenueBarChartType">
                        </canvas>
                    </div>
                </div>


            </div>
        </div>

        <div class="main-right col-md-4
        ">
            <div>

                <div [ngClass]="'bestproduct-tab-active'">
                    <h5>Best Selling Products</h5>
                </div>

                <div class="item-list">

                    <div *ngIf="!isDataLoaded" class="item">
                        <ngx-skeleton-loader class="skelton-best-selling" count="5" [theme]="{ 
                        'border-radius': '6px',
                        height: '30px'
                      }"></ngx-skeleton-loader>
                    </div>
                    <ng-container *ngIf="isDataLoaded && bestSellingProducts.length!=0; else elseBlock">
                        <div>
                            <div *ngFor="let bestProducts of bestSellingProducts ; let i = index" class="item-high">
                                <p> {{bestProducts.item_name}}</p>
                                <div *ngIf="i === 0" class="tag">
                                    <img src='../../../../../assets/icons/best.png' width="30px" alt="" loading="lazy">
                                </div>

                            </div>
                        </div>
                    </ng-container>
                    <ng-template #elseBlock>
                        <div *ngIf="isDataLoaded">
                            <p>No items available.</p>
                        </div>
                    </ng-template>


                </div>

            </div>

        </div>


    </div>
</div>